import styled from "styled-components";

const LoaderContainer = styled.div`
  /*width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  top: 0;
  left: 0;
  z-index: 20;*/

  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 20;

  /*height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;*/
`;
export default LoaderContainer;
